import Layout from '@/layout'
// 角色 0 个人 1培训机构 2行政 3企业 4总账 5back
const RouterConfig = [
  {
    path: '/page',
    component: Layout,
    redirect: '/page/index',
    hidden: true,
    children: [
      {
        path: 'index',
        component: () => import('@/views/initial-page'),
        name: 'initialPage',
        meta: {
          title: '首页',
          icon: 'el-icon-house'
        }
      },
      {
        path: 'second',
        component: () => import('@/views/initial-page/second'),
        name: 'initialPage',
        meta: {
          title: '首页',
          icon: 'el-icon-house'
        }
      },
      {
        path: 'homeList',
        component: () => import('@/views/initial-page/homeList'),
        name: 'homeList',
        meta: {
          title: '首页',
          icon: 'el-icon-house'
        }
      },
      {
        path: 'homeListForZcfg',
        component: () => import('@/views/initial-page/homeListForZcfg'),
        name: 'homeListForZcfg',
        meta: {
          title: '首页',
          icon: 'el-icon-house'
        }
      },
      {
        path: 'homeDetail',
        component: () => import('@/views/initial-page/homeDetail'),
        name: 'homeDetail',
        meta: {
          title: '首页',
          icon: 'el-icon-house'
        }
      },
      {
        path: 'help',
        component: () => import('@/views/help'),
        name: 'help',
        meta: {
          title: '驱动下载',
          icon: 'el-icon-house'
        }
      },
    ]
  },
  {
    path: '/organInfo',
    component: Layout,
    redirect: '/organInfo/info',
    meta: {
      roles: [5],
    },
    children: [
      { // 原'/workList'
        path: 'info',
        component: () => import('@/views/organ-manage/backInfo'),
        name: 'organInfo',
        meta: {
          title: '机构模板管理',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/organInfo',
    component: Layout,
    redirect: '/organInfo/info',
    meta: {
      roles: [1],
    },
    children: [
      { // 原'/workList'
        path: 'info',
        component: () => import('@/views/organ-manage/info'),
        name: 'organInfo',
        meta: {
          title: '机构管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/groupTrainManage',
    component: Layout,
    redirect: '/companyTrainManage/planManage',
    meta: {
      icon: 'el-icon-s-check',
      role: [1],
    },
    children: [
      { // 原/trainingPlanAdd1
        path: 'trainingPlanAdd1',
        component: () => import('@/views/company-train-manage/training-plan-add1'),
        name: 'trainingPlanAdd1',
        meta: {
          title: '计划管理',
          roles: [1],
        }
      },
    ]
  },
  {
    path: '/video',
    component: Layout,
    redirect: '/page/index',
    hidden: true,
    meta: {
      title: '监控管理',
      icon: 'el-icon-house'
    },
    children: [
      {
        path: 'videoMessage',
        component: () => import('@/views/video-manage/videoMessage'),
        name: 'videoMessage',
        hidden: true,
        meta: {
          title: '系统设置',
        }
      },
      {
        path: 'videoList',
        component: () => import('@/views/video-manage/videoList'),
        name: 'videoList',
        hidden: true,
        meta: {
          title: '视频监控',
        }
      },
    ]
  },
  {
    path: '/classPlanTemplate',
    component: Layout,
    redirect: '/classPlanTemplate/list',
    hidden: true,
    meta: {
      title: '教学计划实施表-模板',
      icon: 'el-icon-house'
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/class-plan-template'),
        name: 'classPlanTemplateList',
        hidden: true,
        meta: {
          title: '列表',
        },
      },
    ]
  },
  {
    path: '/tab',
    component: Layout,
    redirect: '/tab/manage',
    hidden: true,
    children: [
      {
        path: 'manage',
        component: () => import('@/views/tab-manage'),
        name: 'tabManage',
        hidden: true,
        meta: {
          title: '消息',
          role: [1, 2, 3, 4, 5],
          icon: 'el-icon-house'
        }
      },
    ]
  },
  {
    path: '/companyInfo',
    component: Layout,
    redirect: '/companyInfo/index',
    children: [
      {
        path: 'index',
        component: () => import('@/views/company-info-page'),
        name: 'companyInfo',
        meta: {
          title: '企业信息',
          roles: [3],
          icon: 'el-icon-s-custom'
        }
      },
      {
        path: 'mapWord',
        component: () => import('@/views/company-info-page/mapWord'),
        name: 'mapWord',
        hidden: true,
        meta: {
          title: '地图',
          roles: [3],
          icon: 'el-icon-s-custom'
        }
      }
    ]
  },
  {
    path: '/user',
    component: Layout,
    redirect: '/user/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/user-manage'),
        name: 'userManage',
        meta: {
          title: '人员管理',
          roles: [3],
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '/companyPlan',
    component: Layout,
    redirect: '/companyPlan/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/company-plan-manage'),
        name: 'companyPlanManage',
        meta: {
          title: '企业计划管理',
          roles: [3],
          icon: 'el-icon-user'
        }
      }
    ]
  },

  {
    path: '/signManage',
    component: Layout,
    redirect: '/signManage/specialOperation',
    meta: {
      title: '报名管理',
      icon: 'el-icon-s-check'
    },
    children: [
      {
        // path: 'sign',
        // component: () => import('@/views/sign-manage/sign'),
        // name: 'sign',
        // meta: {
        //   title: '培训报名',
        //   roles: [3],
        //   icon: 'el-icon-user'
        // },
        // children: [
          // {
            path: 'specialOperation',
            component: () => import('@/views/sign-manage/sign/special-operation'),
            name: 'specialOperation',
            meta: {
              title: '特种作业报名',
              roles: [0, 1, 3],
            },
          // }
        // ]
      },
      // {
      //   path: 'specialOperation',
      //   component: () => import('@/views/sign-manage/sign/special-operation/student'),
      //   name: 'specialOperation',
      //   meta: {
      //     title: '特种作业报名',
      //     roles: [0],
      //   },
      // },
      {
        path: 'specialEquipment',
        component: () => import('@/views/sign-manage/sign/special-equipment'),
        name: 'specialOperation',
        meta: {
          title: '特种设备报名',
          roles: [0, 1, 3],
        },
      },
      // {
      //   path: 'specialEquipment',
      //   component: () => import('@/views/sign-manage/sign/special-equipment/student'),
      //   name: 'specialOperation',
      //   meta: {
      //     title: '特种设备报名',
      //     roles: [0],
      //   },
      // },
      {
        path: 'specialChemistry',
        component: () => import('@/views/sign-manage/sign/special-chemistry'),
        name: 'specialOperation',
        meta: {
          title: '危化企业报名',
          roles: [0, 1, 3],
        },
      },
      // {
      //   path: 'specialChemistry',
      //   component: () => import('@/views/sign-manage/sign/special-chemistry/student'),
      //   name: 'specialOperation',
      //   meta: {
      //     title: '危化企业报名',
      //     roles: [0],
      //   },
      // },
      {
        path: 'specialBusiness',
        component: () => import('@/views/sign-manage/sign/special-business'),
        name: 'specialOperation',
        meta: {
          title: '负责人安全员报名',
          roles: [0, 1, 3],
        },
      },
      // {
      //   path: 'specialBusiness',
      //   component: () => import('@/views/sign-manage/sign/special-business/student'),
      //   name: 'specialOperation',
      //   meta: {
      //     title: '生产企业报名',
      //     roles: [0],
      //   },
      // },
      // {   // 先去除
      //   path: 'specialSkill',
      //   component: () => import('@/views/sign-manage/sign/special-skill'),
      //   name: 'specialOperation',
      //   meta: {
      //     title: '技能提升报名',
      //     roles: [0, 1, 3],
      //   },
      // },
      // {
      //   path: 'specialSkill',
      //   component: () => import('@/views/sign-manage/sign/special-skill/student'),
      //   name: 'specialOperation',
      //   meta: {
      //     title: '技能提升报名',
      //     roles: [0],
      //   },
      // },
      {
        path: 'signHistory',
        component: () => import('@/views/sign-manage/sign-history/studentOrder'),
        name: 'signHistory',
        meta: {
          title: '报名数据',
          roles: [0, 3],
        }
      },
      {
        path: 'signHistory',
        component: () => import('@/views/sign-manage/sign-history/studentOrder'),
        name: 'signHistory',
        meta: {
          title: '个人数据',
          roles: [1],
        }
      },
      {
        path: 'jntsOrder',
        component: () => import('@/views/sign-manage/sign-history/jntsOrder'),
        name: 'jntsOrder',
        meta: {
          title: '企业数据',
          roles: [1],
        }
      },
      {
        path: 'jntsOrderdlist',
        component: () => import('@/views/sign-manage/sign-history/jntsOrderdlist'),
        name: 'jntsOrderdlist',
        hidden: true,
        meta: {
          title: '企业报名明细',
          roles: [0, 1, 2, 3, 4],
        }
      },
      {
        path: 'jntsOrderdlistForSelf',
        component: () => import('@/views/sign-manage/sign-history/jntsOrderdlistForSelf'),
        name: 'jntsOrderdlistForSelf',
        hidden: true,
        meta: {
          title: '企业数据-个人明细',
          roles: [0, 1, 2, 3, 4],
        }
      },
      {
        path: 'signData',
        component: () => import('@/views/sign-manage/sign-data'),
        name: 'signData',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 3],
        }
      },
      {
        path: 'signDataDetail',
        component: () => import('@/views/sign-manage/sign-data/detail'),
        name: 'signDataDetail',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 3],
        }
      },
    ]
  },
  {
    path: '/trainManage',
    component: Layout,
    redirect: '/trainManage/teachingAffairsManage',
    hidden: true,
    meta: {
      title: '培训管理',
      icon: 'el-icon-s-check'
    },
    children: [
      {
        path: 'classScheduleManage',
        component: () => import('@/views/train-manage/class-schedule-manage'),
        name: 'classScheduleManage',
        meta: {
          title: '排班管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'teachingAffairsManage',
        component: () => import('@/views/train-manage/teaching-affairs-manage'),
        name: 'teachingAffairsManage',
        meta: {
          title: '教务管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'attendanceManage',
        component: () => import('@/views/train-manage/attendance-manage'),
        name: 'attendanceManage',
        meta: {
          title: '考勤管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'qualityManage',
        component: () => import('@/views/train-manage/quality-manage'),
        name: 'qualityManage',
        meta: {
          title: '质量管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '/companyTrainManage',
    component: Layout,
    redirect: '/companyTrainManage/planManage',
    meta: {
      title: '培训管理',
      icon: 'el-icon-s-check',
      role: [3],
    },
    children: [
      { // 原/busniesPlan
        path: 'planManage',
        component: () => import('@/views/company-train-manage/plan-manage365'),
        name: 'planManage365',
        hidden: true,
        meta: {
          title: '计划管理',
          roles: [3],
        }
      },
      { // 原/busniesPlan
        path: 'planManageSelf',
        component: () => import('@/views/company-train-manage/plan-manage'),
        name: 'planManage',
        meta: {
          title: '计划管理',
          roles: [3],
        }
      },
      {
       // 原/busniesPlan
       path: 'departExamineManage',
       component: () => import('@/views/company-train-manage/depart-examine-manage'),
       name: 'departExamineManage',
       meta: {
         title: '部门考核管理',
         roles: [3],
       }
      },
      {
        // 原/busniesPlan
        path: 'departExamineStudentManage',
        component: () => import('@/views/company-train-manage/depart-examine-manage/student'),
        name: 'departExamineStudentManage',
        hidden: true,
        meta: {
          title: '部门考核管理-人员',
          roles: [3],
        }
       },
       {
        // 原/busniesPlan
        path: 'departExamineStudentDetailManage',
        component: () => import('@/views/company-train-manage/depart-examine-manage/studentDetail'),
        name: 'departExamineStudentManage',
        hidden: true,
        meta: {
          title: '部门考核管理-人员-证书',
          roles: [3],
        }
       },
      { // 原/trainingPlanAdd1
        path: 'trainingPlanAdd1',
        component: () => import('@/views/company-train-manage/training-plan-add1'),
        name: 'trainingPlanAdd1',
        hidden: true,
        meta: {
          title: '计划管理',
          roles: [1],
        }
      },
      { // 原/trainingPlanAdd1f
        path: 'trainingPlanAdd1f',
        component: () => import('@/views/company-train-manage/training-plan-add1f'),
        name: 'trainingPlanAdd1f',
        hidden: true,
        meta: {
          title: '计划管理',
          roles: [1],
        }
      },
      {
        path: 'examineManageSelf',
        component: () => import('@/views/company-train-manage/examine-manage'),
        name: 'examineManage',
        meta: {
          title: '考核管理',
          roles: [3],
        }
      },
      { // 365使用
        path: 'examineManage',
        component: () => import('@/views/company-train-manage/examine-manage365'),
        name: 'examineManage365',
        hidden: true,
        meta: {
          title: '档案管理',
          roles: [3],
        }
      },
      {
        path: 'examineInfo',
        component: () => import('@/views/company-train-manage/examine-manage/info'),
        name: 'examineInfo',
        hidden: true,
        meta: {
          title: '考核详情',
          roles: [3],
        }
      },
      {
        path: 'studentOrderPaibanst0',
        component: () => import('@/views/company-train-manage/student-order-paibanst0'),
        name: 'studentOrderPaibanst0',
        meta: {
          title: '排班管理',
          roles: [1],
        }
      },
      {
        path: 'studentOrderPaibanDetail',
        component: () => import('@/views/company-train-manage/student-order-paibanst0/studentOrderPaibanDetail'),
        name: 'studentOrderPaibanDetail',
        hidden: true,
        meta: {
          title: '排班明细',
          roles: [1],
        }
      },
      {
        path: 'studentOrderPaibanst1',
        component: () => import('@/views/company-train-manage/student-order-paibanst0/studentOrderPaibanst1'),
        name: 'studentOrderPaibanst1',
        hidden: true,
        meta: {
          title: '排班管理',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanCommon',
        component: () => import('@/views/company-train-manage/student-paiban-common'),
        name: 'studentPaibanCommon',
        meta: {
          title: '教务管理',
          roles: [1],
        }
      },
      {
        path: 'workAttendance',
        component: () => import('@/views/company-train-manage/work-attendance'),
        name: 'workAttendance',
        meta: {
          title: '考勤管理',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanCommon2',
        component: () => import('@/views/company-train-manage/student-paiban-common2'),
        name: 'studentPaibanCommon2',
        meta: {
          title: '质量管理',
          roles: [1],
        }
      },
    ]
  },
  {
    path: '/student',
    component: Layout,
    redirect: '/student/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/student-manage'),
        name: 'userManage',
        meta: {
          title: '学员管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'viewCert',
        component: () => import('@/views/student-manage/viewCert'),
        name: 'viewCert',
        hidden: true,
        meta: {
          title: '学员管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '/examManage',
    component: Layout,
    redirect: '/examManage/busexamPlan',
    meta: {
      title: '考试管理',
      icon: 'el-icon-s-check'
    },
    children: [
      {
        path: 'busexamPlan',
        component: () => import('@/views/exam-manage/busexam-plan'),
        name: 'busexamPlan',
        meta: {
          title: '考试计划',
          roles: [1],
        }
      },
      {
        path: 'examApplyStudent',
        component: () => import('@/views/exam-manage/examApplyStudent'),
        name: 'examApplyStudent',
        hidden: true,
        meta: {
          title: '学员列表',
          roles: [1],
        }
      },
      {
        path: 'busexamApplylist',
        component: () => import('@/views/exam-manage/busexam-apply-list'),
        name: 'busexamApplylist',
        meta: {
          title: '考试申请',
          roles: [1],
        }
      },
      {
        path: 'busexamResult',
        component: () => import('@/views/exam-manage/busexam-result'),
        name: 'busexamResult',
        meta: {
          title: '考试结果',
          roles: [1],
        }
      },
      {
        path: 'kscardmanage',
        component: () => import('@/views/exam-manage/kscardmanage'),
        name: 'kscardmanage',
        meta: {
          title: '证书申请',
          roles: [1],
        }
      },
    ]
  },
  {
    path: '/studentExamManage',
    component: Layout,
    redirect: '/studentExamManage/manage',
    hidden: true,
    children: [
      {
        path: 'manage',
        component: () => import('@/views/student-exam-manage'),
        name: 'userManage',
        meta: {
          title: '考试不合格记录',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'personManage',
        component: () => import('@/views/student-exam-manage/personal'),
        name: 'userManage',
        meta: {
          title: '考试不合格记录',
          roles: [1],
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '/cert',
    component: Layout,
    redirect: '/cert/manage',
    children: [
      // { 
      //   path: 'manage',
      //   component: () => import('@/views/cert-manage'),
      //   name: 'certManage',
      //   meta: {
      //     title: '证书管理',  //  原有的企业证书管理，先删除
      //     roles: [3],
      //     icon: 'el-icon-user'
      //   }
      // },
      {
        path: 'manage',
        component: () => import('@/views/cert-manage/groupManage'),
        name: 'certManage',
        meta: {
          title: '证书管理',
          roles: [1, 3],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'groupManageInfo',
        component: () => import('@/views/cert-manage/groupManageInfo'),
        name: 'certManage',
        hidden: true,
        meta: {
          title: '证书列表',
          roles: [1, 3],
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '/teacherfileManage',
    component: Layout,
    redirect: '/teacherfileManage/newManage',
    children: [
      {
        path: 'newManage',
        component: () => import('@/views/teacher-file-manage/newIndex'),
        name: 'teacherfileManage',
        meta: {
          title: '档案管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'manageInfo',
        component: () => import('@/views/teacher-file-manage/info'),
        name: 'teacherfileManage',
        hidden: true,
        meta: {
          title: '档案管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'manage',
        component: () => import('@/views/teacher-file-manage'),
        name: 'teacherfileManage',
        hidden: true,
        meta: {
          title: '档案管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'noBanForExcel',
        component: () => import('@/views/teacher-file-manage/noBanForExcel'),
        name: 'noBanForExcel',
        hidden: true,
        meta: {
          title: '一期一表',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'studentForExcel',
        component: () => import('@/views/teacher-file-manage/studentForExcel'),
        name: 'studentForExcel',
        hidden: true,
        meta: {
          title: '一人一表',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'studentForExcelCert',
        component: () => import('@/views/teacher-file-manage/studentForExcel/certList'),
        name: 'studentForExcelCert',
        hidden: true,
        meta: {
          title: '一人一表',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'studentPaibanClassopen',
        component: () => import('@/views/company-train-manage/student-paiban-common/studentPaibanClassopen'),
        name: 'studentPaibanClassopen',
        hidden: true,
        meta: {
          title: '开班信息表',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanClassplan',
        component: () => import('@/views/company-train-manage/student-paiban-common/studentPaibanClassplan'),
        name: 'studentPaibanClassplan',
        hidden: true,
        meta: {
          title: '教学实施计划表',
          roles: [1],
        }
      },
      {
        path: 'studentPaibankjsp',
        component: () => import('@/views/company-train-manage/student-paiban-common/studentPaibankjsp'),
        name: 'studentPaibankjsp',
        hidden: true,
        meta: {
          title: '教案审批表',
          roles: [1],
        }
      },
      {
        path: 'studentClasstable',
        component: () => import('@/views/teacher-file-manage/studentClasstable'),
        name: 'studentClasstable',
        hidden: true,
        meta: {
          title: '培训课程表',
          roles: [1],
        }
      },
      {
        path: 'studentClassjyhd',
        component: () => import('@/views/teacher-file-manage/studentClassjyhd'),
        name: 'studentClassjyhd',
        hidden: true,
        meta: {
          title: '教研活动记录表',
          roles: [1],
        }
      },
      {
        path: 'studentClasspxxydj',
        component: () => import('@/views/teacher-file-manage/studentClasspxxydj'),
        name: 'studentClasspxxydj',
        hidden: true,
        meta: {
          title: '培训学员登记表',
          roles: [1],
        }
      },
      {
        path: 'studentClasspxxymc',
        component: () => import('@/views/teacher-file-manage/studentClasspxxymc'),
        name: 'studentClasspxxymc',
        hidden: true,
        meta: {
          title: '培训学员名册',
          roles: [1],
        }
      },
      {
        path: 'studentClasspxxykqqd',
        component: () => import('@/views/teacher-file-manage/studentClasspxxykqqd'),
        name: 'studentClasspxxykqqd',
        hidden: true,
        meta: {
          title: '培训学员考勤签到表',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanTeachlog',
        component: () => import('@/views/company-train-manage/student-paiban-common/studentPaibanTeachlog'),
        name: 'studentPaibanTeachlog',
        hidden: true,
        meta: {
          title: '教学日志',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanjxpj',
        component: () => import('@/views/company-train-manage/student-paiban-common2/studentPaibanjxpj'),
        name: 'studentPaibanjxpj',
        hidden: true,
        meta: {
          title: '课堂教学评价表',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanTeachQulity',
        component: () => import('@/views/company-train-manage/student-paiban-common2/studentPaibanTeachQulity'),
        name: 'studentPaibanTeachQulity',
        hidden: true,
        meta: {
          title: '教师教学质量评估表',
          roles: [1],
        }
      },
      {
        path: 'studentPaibanClassSumup',
        component: () => import('@/views/company-train-manage/student-paiban-common/studentPaibanClassSumup'),
        name: 'studentPaibanClassSumup',
        hidden: true,
        meta: {
          title: '培训班总结',
          roles: [1],
        }
      },
      {
        path: 'studentClasspxkcshpj',
        component: () => import('@/views/teacher-file-manage/studentClasspxkcshpj'),
        name: 'studentClasspxkcshpj',
        hidden: true,
        meta: {
          title: '培训课程设计评价表',
          roles: [1],
        }
      },
      {
        path: 'studentClassaqpxzth',
        component: () => import('@/views/teacher-file-manage/studentClassaqpxzth'),
        name: 'studentClassaqpxzth',
        hidden: true,
        meta: {
          title: '安全培训座谈会记录',
          roles: [1],
        }
      },
      {
        path: 'studentClasstksq',
        component: () => import('@/views/teacher-file-manage/studentClasstksq'),
        name: 'studentClasstksq',
        hidden: true,
        meta: {
          title: '调课申请表',
          roles: [1],
        }
      },
    ]
  },
  {
    path: '/paper',
    component: () => import('@/views/train-center/layout'),
    redirect: '/paper/studentTestPaperForScan',
    children: [
      {
        path: 'studentTestPaperForScan',
        component: () => import('@/views/train-center/studentTestPaperForScan'),
        name: 'studentTestPaperForScan',
        hidden: true,
        meta: {
          title: '考卷分析查看',
          icon: '',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
    ]
  },
  {
    path: '/trainCenter',
    component: Layout,
    redirect: '/trainCenter/center',
    meta: {
      title: '培训中心',
      icon: 'el-icon-s-check'
    },
    children: [
      {
        path: 'companyCourse',
        component: () => import('@/views/train-center'),
        name: 'companyCourse',
        meta: {
          title: '企业课程',
          roles: [0, 1, 3],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'certCourse',
        component: () => import('@/views/train-center'),
        name: 'certCourse',
        meta: {
          title: '持证课程',
          roles: [0, 1, 3],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'studentVideo',
        component: () => import('@/views/train-center/studentVideo'),
        name: 'studentVideo',
        hidden: true,
        meta: {
          title: '视频学习',
          roles: [0, 1, 3],
          icon: ''
        }
      },
      {
        path: 'studentFilePreview',
        component: () => import('@/views/train-center/studentFilePreview'),
        name: 'studentFilePreview',
        hidden: true,
        meta: {
          title: '课件学习',
          roles: [0, 1, 3],
          icon: ''
        }
      },
      {
        path: 'studentPPT',
        component: () => import('@/views/train-center/studentPPT'),
        name: 'studentPPT',
        hidden: true,
        meta: {
          title: '课件学习',
          roles: [0, 1, 3],
          icon: ''
        }
      },
      {
        path: 'centralismTraining1',
        component: () => import('@/views/train-center/centralismTraining'),
        name: 'centralismTraining1',
        hidden: true,
        meta: {
          title: '集中培训',
          roles: [0, 3],
          icon: ''
        }
      },
      {
        path: 'centralismTraining',
        component: () => import('@/views/train-center/centralized-training'),
        name: 'centralismTraining',
        hidden: true,
        meta: {
          title: '集中培训',
          roles: [0, 3],
          icon: ''
        }
      },
      {
        path: 'centralismTrainingAdd',
        component: () => import('@/views/train-center/centralized-training/add'),
        name: 'centralismTrainingAdd',
        hidden: true,
        meta: {
          title: '集中培训',
          roles: [0, 3],
          icon: ''
        }
      },
      {
        path: 'centralismTrainingStudent',
        component: () => import('@/views/train-center/centralized-training/student'),
        name: 'centralismTrainingStudent',
        hidden: true,
        meta: {
          title: '集中培训',
          roles: [0, 3],
          icon: ''
        }
      },
      {
        path: 'studentTestPaper',
        component: () => import('@/views/train-center/studentTestPaper'),
        name: 'studentTestPaper',
        hidden: true,
        meta: {
          title: '考卷',
          roles: [0, 1, 3],
          icon: ''
        }
      },
      {
        path: 'studentTestPaperForScan',
        component: () => import('@/views/train-center/studentTestPaperForScan'),
        name: 'studentTestPaperForScan1',
        hidden: true,
        meta: {
          title: '考卷分析查看',
          icon: '',
          roles: [0, 1, 2, 3, 4],
        }
      },
      {
        path: 'analysis',
        component: () => import('@/views/train-center/analysis'),
        name: 'analysis',
        hidden: true,
        meta: {
          title: '考试列表',
          roles: [0, 3],
          icon: ''
        }
      },
    ]
  },
  {
    path: '/examManage',
    component: Layout,
    hidden: true,
    redirect: '/examManage/busexamPlan',
    meta: {
      title: '考试管理',
      icon: 'el-icon-s-check'
    },
    children: [
      {
        path: 'curriculumExam',
        component: () => import('@/views/exam-manage/curriculumExam'),
        name: 'curriculumExam',
        hidden: true,
        meta: {
          title: '试卷管理',
          roles: [5],
        }
      }
    ]
  },
  {
    path: '/courseManage',
    component: Layout,
    redirect: '/courseManage/busexamPlan',
    meta: {
      title: '课程管理',
      icon: 'el-icon-s-check'
    },
    children: [
      {
        path: 'curriculumList',
        component: () => import('@/views/course-manage/course-file-manage'),
        name: 'curriculumList',
        meta: {
          title: '课件管理',
          roles: [1, 3, 5],
        }
      },
      {
        path: 'curriculumType',
        component: () => import('@/views/course-manage/curriculum-type-manage'),
        name: 'curriculumType',
        meta: {
          title: '企业课程分类',
          roles: [5],
        }
      },
    ]
  },
  {
    path: '/indexMenu',
    component: Layout,
    redirect: '/indexMenu/manage',
    meta: {
      title: '首页模块',
      icon: 'el-icon-user'
    },
    children: [
      {
        path: 'manage',
        component: () => import('@/views/index-menu-manage/menu'),
        name: 'indexMenuManage',
        meta: {
          title: '首页模块管理',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'policyManage',
        component: () => import('@/views/index-menu-manage/policy-manage'),
        name: 'policyManage',
        meta: {
          title: '政策法规管理',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/company',
    component: Layout,
    redirect: '/company/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/company-manage'),
        name: 'companyManage',
        meta: {
          title: '企业管理',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/registerUser',
    component: Layout,
    redirect: '/registerUser/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/register-user-manage'),
        name: 'companyManage',
        meta: {
          title: '注册人员信息',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'info',
        component: () => import('@/views/company-info-page'),
        name: 'backCompanyInfo',
        hidden: true,
        meta: {
          title: '企业信息',
          roles: [5],
          icon: 'el-icon-s-custom'
        }
      },
    ]
  },
  {
    path: '/organ',
    component: Layout,
    redirect: '/organ/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/organ-manage'),
        name: 'organManage',
        meta: {
          title: '培训机构管理',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
      { // 原'/workList'
        path: 'info',
        component: () => import('@/views/organ-manage/info'),
        name: 'organInfo',
        hidden: true,
        meta: {
          title: '培训机构详情',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      { // 原'/organDetail'
        path: 'organElementManage',
        component: () => import('@/views/organ-manage/organ-element-manage'),
        name: 'organElementManage',
        hidden: true,
        meta: {
          title: '要素管理',
          roles: [1, 5],
          icon: 'el-icon-user'
        }
      },
      { // 原'/organDetail'
        path: 'cxWordDetail',
        component: () => import('@/views/organ-manage/cx-word-detail'),
        name: 'cxWordDetail',
        hidden: true,
        meta: {
          title: '文档编辑',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/government',
    component: Layout,
    redirect: '/government/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/government-manage'),
        name: 'governmentManage',
        meta: {
          title: '政府账号管理',
          roles: [5],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/depart',
    component: Layout,
    redirect: '/depart/manage',
    children: [
      {
        path: 'manage',
        component: () => import('@/views/depart-manage'),
        name: 'departManage',
        meta: {
          title: '部门管理',
          roles: [3],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/systemNotice',
    component: Layout,
    redirect: '/systemNotice/list',
    children: [
      {
        path: 'list',
        component: () => import('@/views/system-notice'),
        name: 'systemNoticeList',
        meta: {
          title: '系统公告',
          roles: [0, 1, 3],
          icon: 'el-icon-user'
        }
      }
    ]
  },
  {
    path: '/messageList',
    component: Layout,
    redirect: '/messageList/list',
    meta: {
      title: '信息互动',
      icon: 'el-icon-user'
    },
    children: [
      {
        path: 'list',
        component: () => import('@/views/message-list'),
        name: 'messageList',
        meta: {
          title: '信息互动',
          roles: [0, 3],
        }
      },
      {
        path: 'messageInteraction',
        component: () => import('@/views/message-list/messageInteraction'),
        name: 'messageInteraction',
        meta: {
          title: '发送的列表',
          roles: [3],
        }
      },
    ]
  },
  {
    path: '/messageList',
    component: Layout,
    redirect: '/messageList/messageInteraction',
    meta: {
      title: '信息互动',
      icon: 'el-icon-user'
    },
    children: [
      {
        path: 'messageInteraction',
        component: () => import('@/views/message-list/messageInteraction'),
        name: 'messageInteraction',
        meta: {
          title: '发送的列表',
          roles: [1],
        }
      },
      {
        path: 'messageLeaving',
        component: () => import('@/views/message-list/messageLeaving'),
        name: 'messageLeaving',
        meta: {
          title: '接收的列表',
          roles: [1],
        }
      },
      {
        path: 'fxTipsList',
        component: () => import('@/views/message-list/fx-tips-list'),
        name: 'fxTipsTemplate',
        meta: {
          title: '复训提醒',
          roles: [0, 1],
        }
      },
    ]
  },
  {
    path: '/questionBank',
    component: Layout,
    redirect: '/questionBank/list',
    children: [
      {
        path: 'list',
        component: () => import('@/views/question-bank'),
        name: 'questionBankList',
        hidden: true,
        meta: {
          title: '题库',
          roles: [0, 3, 5],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/comment',
    component: Layout,
    redirect: '/comment/list',
    children: [
      { // 原 /messageInReply
        path: 'list',
        component: () => import('@/views/comment-list'),
        name: 'commentList',
        meta: {
          title: '留言管理',
          roles: [0, 1],
          icon: 'el-icon-user'
        }
      },
      { // 原 /messageInReplyDetail
        path: 'commentInfo',
        component: () => import('@/views/comment-list/info'),
        name: 'commentInfo',
        hidden: true,
        meta: {
          title: '留言详情',
          roles: [0, 1, 3],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/financeManage',
    component: Layout,
    redirect: '/financeManage/manage',
    meta: {
      icon: 'el-icon-s-check',
    },
    children: [
      {
        path: 'manage',
        component: () => import('@/views/finance-manage'),
        name: 'financeManage',
        meta: {
          title: '绩效管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'financeIndexL1',
        component: () => import('@/views/finance-manage/financeIndexL1'),
        name: 'financeIndexL1',
        hidden: true,
        meta: {
          title: '绩效管理',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/userCenter',
    component: Layout,
    redirect: '/userCenter/examineHistory',
    meta: {
      title: '个人中心',
      icon: 'el-icon-s-check',
    },
    hidden: true,
    children: [
      {
        path: 'examineHistory',
        component: () => import('@/views/user-center/examine-history'),
        name: 'examineHistory',
        meta: {
          title: '考核记录',
          roles: [1],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/userCenter',
    component: Layout,
    redirect: '/userCenter/examineHistory',
    meta: {
      title: '个人中心',
      icon: 'el-icon-s-check',
    },
    children: [
      {
        path: 'examineHistory',
        component: () => import('@/views/user-center/examine-history'),
        name: 'examineHistory',
        meta: {
          title: '考核记录',
          roles: [0],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'accountManage',
        component: () => import('@/views/user-center/account'),
        name: 'accountManage',
        meta: {
          title: '账号管理',
          roles: [0],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'analysis',
        component: () => import('@/views/train-center/analysis'),
        name: 'analysis',
        meta: {
          title: '考试列表',
          roles: [0],
          icon: 'el-icon-user'
        }
      },
    ]
  },
  {
    path: '/classRoom',
    component: Layout,
    hidden: true,
    children: [
      {
        path: 'classopen',
        component: () => import('@/views/company-train-manage/class-room/classopen'),
        name: 'classopen',
        meta: {
          title: '开班信息表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classtable',
        component: () => import('@/views/company-train-manage/class-room/classtable'),
        name: 'classtable',
        meta: {
          title: '培训课程表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classplan',
        component: () => import('@/views/company-train-manage/class-room/classplan'),
        name: 'classplan',
        meta: {
          title: '教学实施计划表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classkjsp',
        component: () => import('@/views/company-train-manage/class-room/classkjsp'),
        name: 'classkjsp',
        meta: {
          title: '课件审批表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classroomsumup',
        component: () => import('@/views/company-train-manage/class-room/classroomsumup'),
        name: 'classroomsumup',
        meta: {
          title: '培训班总结',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classteacherlog',
        component: () => import('@/views/company-train-manage/class-room/classteacherlog'),
        name: 'classteacherlog',
        meta: {
          title: '培训日志表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'workAttendanceDetail',
        component: () => import('@/views/company-train-manage/work-attendance/workAttendanceDetail'),
        name: 'workAttendanceDetail',
        meta: {
          title: '培训学员考勤签到表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'teacherappraise',
        component: () => import('@/views/company-train-manage/class-room/teacherappraise'),
        name: 'teacherappraise',
        meta: {
          title: '课堂教学评价表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'teacherquality',
        component: () => import('@/views/company-train-manage/class-room/teacherquality'),
        name: 'teacherquality',
        meta: {
          title: '教师教学质量评估表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'examApplyDetail',
        component: () => import('@/views/company-train-manage/class-room/examApplyDetail'),
        name: 'examApplyDetail',
        meta: {
          title: '考试申请汇总表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'classactive',
        component: () => import('@/views/company-train-manage/class-room/classactive'),
        name: 'classactive',
        meta: {
          title: '教研活动记录表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'studentreg',
        component: () => import('@/views/company-train-manage/class-room/studentreg'),
        name: 'studentreg',
        meta: {
          title: '培训学员登记表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'studentreglist',
        component: () => import('@/views/company-train-manage/class-room/studentreglist'),
        name: 'studentreglist',
        meta: {
          title: '培训学员名册',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'studentattendf',
        component: () => import('@/views/company-train-manage/class-room/studentattendf'),
        name: 'studentattendf',
        meta: {
          title: '培训学员考勤登记表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'teachermaterials',
        component: () => import('@/views/company-train-manage/class-room/teachermaterials'),
        name: 'teachermaterials',
        meta: {
          title: '培训课程设计评价表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'classtalk',
        component: () => import('@/views/company-train-manage/class-room/classtalk'),
        name: 'classtalk',
        meta: {
          title: '安全培训座谈会记录',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'classprochange',
        component: () => import('@/views/company-train-manage/class-room/classprochange'),
        name: 'classprochange',
        meta: {
          title: '调课申请表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'examcardDetail',
        component: () => import('@/views/company-train-manage/class-room/examcardDetail'),
        name: 'examcardDetail',
        meta: {
          title: '操作证申请汇总表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'bminfoedit',
        component: () => import('@/views/company-train-manage/class-room/bminfoedit'),
        name: 'bminfoedit',
        meta: {
          title: '信息修改申请书',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'trainingCertificat',
        component: () => import('@/views/company-train-manage/class-room/trainingCertificat'),
        name: 'trainingCertificat',
        meta: {
          title: '培训证明',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'certApplySelf',
        component: () => import('@/views/company-train-manage/class-room/certApplySelf'),
        name: 'certApplySelf',
        meta: {
          title: '证书申请表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
    ]
  },
  {
    path: '/print',
    component: () => import('@/views/print'),
    hidden: true,
    children: [
      {
        path: 'bminfoedit',
        component: () => import('@/views/print/components/bminfoedit'),
        name: 'bminfoedit',
        meta: {
          title: '信息修改申请书',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'classopen',
        component: () => import('@/views/print/components/classopen'),
        name: 'classopen',
        meta: {
          title: '开班信息表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classtable',
        component: () => import('@/views/print/components/classtable'),
        name: 'classtable',
        meta: {
          title: '培训课程表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classplan',
        component: () => import('@/views/print/components/classplan'),
        name: 'classplan',
        meta: {
          title: '教学实施计划表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classkjsp',
        component: () => import('@/views/print/components/classkjsp'),
        name: 'classkjsp',
        meta: {
          title: '课件审批表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classroomsumup',
        component: () => import('@/views/print/components/classroomsumup'),
        name: 'classroomsumup',
        meta: {
          title: '培训班总结',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'classteacherlog',
        component: () => import('@/views/print/components/classteacherlog'),
        name: 'classteacherlog',
        meta: {
          title: '培训日志表',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'workAttendanceDetail',
        component: () => import('@/views/print/components/workAttendanceDetail'),
        name: 'workAttendanceDetail',
        meta: {
          title: '培训学员考勤签到表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'teacherappraise',
        component: () => import('@/views/print/components/teacherappraise'),
        name: 'teacherappraise',
        meta: {
          title: '课堂教学评价表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'teacherquality',
        component: () => import('@/views/print/components/teacherquality'),
        name: 'teacherquality',
        meta: {
          title: '教师教学质量评估表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      // {
      //   path: 'examApplyDetail',
      //   component: () => import('@/views/print/examApplyDetail'),
      //   name: 'examApplyDetail',
      //   meta: {
      //     title: '考试申请汇总表',
      //     roles: [0, 1, 2, 3, 4, 5],
      //   }
      // },
      {
        path: 'classactive',
        component: () => import('@/views/print/components/classactive'),
        name: 'classactive',
        meta: {
          title: '教研活动记录表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'studentreg',
        component: () => import('@/views/print/components/studentreg'),
        name: 'studentreg',
        meta: {
          title: '培训学员登记表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'studentreglist',
        component: () => import('@/views/print/components/studentreglist'),
        name: 'studentreglist',
        meta: {
          title: '培训学员名册',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      // {
      //   path: 'studentattendf',
      //   component: () => import('@/views/print/studentattendf'),
      //   name: 'studentattendf',
      //   meta: {
      //     title: '培训学员考勤登记表',
      //     roles: [0, 1, 2, 3, 4, 5],
      //   }
      // },
      {
        path: 'teachermaterials',
        component: () => import('@/views/print/components/teachermaterials'),
        name: 'teachermaterials',
        meta: {
          title: '培训课程设计评价表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'classtalk',
        component: () => import('@/views/print/components/classtalk'),
        name: 'classtalk',
        meta: {
          title: '安全培训座谈会记录',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'classprochange',
        component: () => import('@/views/print/components/classprochange'),
        name: 'classprochange',
        meta: {
          title: '调课申请表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'cert',
        component: () => import('@/views/print/components/cert'),
        name: 'cert',
        meta: {
          title: '证书',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'uploadCert',
        component: () => import('@/views/print/components/uploadCert'),
        name: 'uploadCert',
        meta: {
          title: '证书',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'trainingCertificat',
        component: () => import('@/views/print/components/trainingCertificat'),
        name: 'trainingCertificat',
        meta: {
          title: '培训证明',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'examAttachment',
        component: () => import('@/views/print/components/examAttachment'),
        name: 'examAttachment',
        meta: {
          title: '申请操作证材料登记表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'examAttachmentList',
        component: () => import('@/views/print/components/examAttachmentList'),
        name: 'examAttachmentList',
        meta: {
          title: '考试操作证材料登记表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      {
        path: 'certApplySelf',
        component: () => import('@/views/print/components/certApplySelf'),
        name: 'certApplySelf',
        meta: {
          title: '证书申请表',
          roles: [0, 1, 2, 3, 4, 5],
        }
      },
      // {
      //   path: 'examcardDetail',
      //   component: () => import('@/views/print/examcardDetail'),
      //   name: 'examcardDetail',
      //   meta: {
      //     title: '证书申请汇总表',
      //     roles: [0, 1, 2, 3, 4, 5],
      //   }
      // },
    ]
  },
  {
    path: '/system',
    component: Layout,
    children: [  
      {
        path: 'messageInteractionDetail',
        component: () => import('@/views/system/messageInteractionDetail'),
        name: 'messageInteractionDetail',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'qrcodeManage',
        component: () => import('@/views/qrcode-manage'),
        name: 'qrcodeManage',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'studentHandbook', // 学员手册
        component: () => import('@/views/system/studentHandbook/index'),
        name: 'studentHandbook',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'studentHandbookDetail', // 学员手册自用
        component: () => import('@/views/system/studentHandbook/studentHandbookDetail'),
        name: 'studentHandbookDetail',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'shareStudentHandbookDetail', // 学员手册分享
        component: () => import('@/views/system/studentHandbook/shareStudentHandbookDetail'),
        name: 'shareStudentHandbookDetail',
        hidden: true,
        meta: {
          title: '',
          roles: [0, 1, 2, 3, 4, 5],
          icon: 'el-icon-user'
        }
      },
      {
        path: 'pxzmManage',
        component: () => import('@/views/pxzm-manage'),
        hidden: true,
        meta: {
          roles: [0, 1, 2, 3, 4, 5]
        }
      },
    ]
  },
  {
    path: '/certPreview',
    component: () => import('@/views/cert-preview'),
    hidden: true,
    meta: {
      roles: [0, 1, 2, 3, 4, 5]
    }
  },
  
  { path: '*', redirect: '/404', hidden: true }
]
export default RouterConfig
